import {AuthGuard} from '../../../shared/services';
import { CategoryAssociationListComponent } from './category-association-list.component';
import {CategoryAssociationListResolver} from './category-association-list.resolver';
import {Route} from '@angular/router';

export const CategoryAssociationListRoutes: Route[] = [
  {
    path: 'list',
    component: CategoryAssociationListComponent,
    canActivate: [AuthGuard],
    resolve: {
      categories: CategoryAssociationListResolver
    }
  }
];
